import { Reducer } from 'redux';

import {
  Actions,
  AUTH_LOGOUT,
  AUTH_SET_ACCESSES,
  AUTH_SET_LABELS,
  AUTH_SET_LABELS_FILLED,
  AUTH_SET_PRIME,
  AUTH_SET_PROFILE,
  AUTH_SET_REFRESHING,
  AUTH_SET_SETUP_COMPLETE,
  AUTH_SET_TOKENS,
  State,
} from '../types';

const initialState: State = {
  accessToken: '',
  refreshToken: '',
  userID: '',
  region: '',
  labelsFilled: false,
  setupComplete: false,
};

const reducer: Reducer<State, Actions> = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_SET_TOKENS:
      return {
        ...state,
        ...action.payload,
      };
    case AUTH_SET_PROFILE:
      return {
        ...state,
        profile: action.payload,
      };
    case AUTH_SET_ACCESSES:
      return {
        ...state,
        allAccess: action.payload,
      };
    case AUTH_SET_PRIME:
      return {
        ...state,
        prime: action.payload,
      };
    case AUTH_SET_REFRESHING:
      return {
        ...state,
        refreshing: action.payload,
      };
    case AUTH_SET_LABELS_FILLED:
      return {
        ...state,
        labelsFilled: action.payload,
      };
    case AUTH_SET_SETUP_COMPLETE:
      return {
        ...state,
        setupComplete: action.payload,
      };
    case AUTH_SET_LABELS:
      return {
        ...state,
        labels: {
          ...state.labels,
          ...action.payload,
        },
      };
    case AUTH_LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
